import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useSearchParams } from "react-router-dom";
import { PartyPopper, Shield, Clapperboard, ArrowRightLeft, Rocket, Flower2, Zap } from "lucide-react";
import AddMusicToVideo from "@/components/funtime/AddMusicToVideo";
import FileTransfer from "@/components/funtime/FileTransfer";
import StarWarGame from "@/components/funtime/StarWarGame";
import GardenEscape from "@/components/funtime/GardenEscape";
import NeonDodge from "@/components/funtime/NeonDodge";

export default function FunTime() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "file-transfer" ? "file-transfer" : "add-music";
  return (
    <div className="space-y-6" data-testid="fun-time-page">
      <div>
        <h1 className="font-mono text-2xl font-bold text-card-foreground flex items-center gap-3">
          <PartyPopper className="w-7 h-7 text-primary" />
          Fun Time
        </h1>
        <p className="font-mono text-xs font-medium text-foreground mt-1">
          A little break from the numbers.
        </p>
      </div>

      <Tabs defaultValue={initialTab} className="space-y-4">
        <TabsList className="bg-emerald-900/40 gap-2 p-1 h-auto" data-testid="fun-time-tabs">
          <TabsTrigger
            value="add-music"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-add-music"
          >
            <Clapperboard className="w-3.5 h-3.5 mr-1.5" />
            Add Music to Video
          </TabsTrigger>
          <TabsTrigger
            value="file-transfer"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-file-transfer"
          >
            <ArrowRightLeft className="w-3.5 h-3.5 mr-1.5" />
            File Transfer
          </TabsTrigger>
          <TabsTrigger
            value="star-war"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-star-war"
          >
            <Rocket className="w-3.5 h-3.5 mr-1.5" />
            Star War
          </TabsTrigger>
          <TabsTrigger
            value="mouse-repel"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-mouse-repel"
          >
            <Flower2 className="w-3.5 h-3.5 mr-1.5" />
            Mouse Repel
          </TabsTrigger>
          <TabsTrigger
            value="neon-dodge"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-neon-dodge"
          >
            <Zap className="w-3.5 h-3.5 mr-1.5" />
            Neon Dodge
          </TabsTrigger>
          <TabsTrigger
            value="more"
            className="sp-3d-tab font-mono text-xs px-4 py-2 rounded-lg data-[state=active]:sp-3d-tab-active"
            data-testid="fun-tab-more"
          >
            More coming soon
          </TabsTrigger>
        </TabsList>

        <TabsContent value="add-music" className="mt-0" data-testid="fun-add-music-panel">
          <AddMusicToVideo />
        </TabsContent>

        <TabsContent value="file-transfer" className="mt-0" data-testid="fun-file-transfer-panel">
          <FileTransfer />
        </TabsContent>

        <TabsContent value="star-war" className="mt-0" data-testid="fun-star-war-panel">
          <StarWarGame />
        </TabsContent>

        <TabsContent value="mouse-repel" className="mt-0" data-testid="fun-mouse-repel-panel">
          <GardenEscape />
        </TabsContent>

        <TabsContent value="neon-dodge" className="mt-0" data-testid="fun-neon-dodge-panel">
          <NeonDodge />
        </TabsContent>

        <TabsContent value="more" className="mt-0">
          <Card className="border-primary/40 bg-primary/5 max-w-xl">
            <CardContent className="p-8 flex flex-col items-center text-center gap-4">
              <PartyPopper className="w-12 h-12 text-primary" />
              <p className="font-mono text-lg font-bold text-card-foreground">More fun on the way</p>
              <p className="font-mono text-xs text-muted-foreground">
                This space is reserved for the next fun tool. Watch this tab for updates.
              </p>
              <div className="flex items-center gap-2 mt-2 px-3 py-1.5 rounded-full bg-amber-500/15 border border-amber-500/40" data-testid="fun-time-admin-badge">
                <Shield className="w-3.5 h-3.5 text-amber-400" />
                <span className="font-mono text-[10px] uppercase tracking-wider text-amber-300">Currently visible to admins only</span>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
